import { UploadCommand, HttpMethod } from "~/extensions/api";
import { store } from "~/pages/shomei/store/ShomeiEntryStore";
import { myPageStore } from "~/store/MyPageStore";
export class InsertShomei extends UploadCommand {
    constructor() {
        super(HttpMethod.Post, "shomei/insert");
    }
    nyukyokeiyakuNo = -1;
    userCd = -1;
    sinseiYmd = null;
    shomeiKb = 0;
    shakoChushamei = "";
    shakoKukaku = "";
    shomeiStatus = 0;
    shomeiReceptionMailDate = null;
    renrakuTel = "";
    renrakuEmail = "";
    soufuName = "";
    soufuPostcode = "";
    soufuAdr1 = "";
    soufuAdr2 = "";
    soufuAdr3 = "";
    shomeiBikou = "";
    createDate = null;
    createAppId = 0;
    updateDate = null;
    updateAppId = 0;
    orgNyukyokeiyakuNo = 0;
    shosikiSiteiKb = 0;
    privacyConsent = null;
    rentStartDate = null;
    rentEndDate = null;
    shinseishaKb = 0;
    shinseishaName = "";
    shinseishaPostcode = "";
    shinseishaAdr1 = "";
    shinseishaAdr2 = "";
    shinseishaAdr3 = "";
    shinseishaTel = "";
    shogakukinKb = 0;
    file = null;
    static create(shomei) {
        let command = new InsertShomei();
        command.shomeiKb = shomei.selectedShomeiKbn == null ? 0 : shomei.selectedShomeiKbn.hanyoCd;
        command.shakoChushamei = shomei.shakoChushamei;
        command.shakoKukaku = shomei.shakoKukaku;
        command.renrakuTel = shomei.tel;
        command.renrakuEmail = shomei.email;
        command.soufuName = shomei.soufuName;
        command.soufuPostcode = shomei.postcode;
        command.soufuAdr1 = shomei.adr1;
        command.soufuAdr2 = shomei.adr2;
        command.soufuAdr3 = shomei.adr3;
        command.soufuAdr3 = shomei.adr3;
        command.shosikiSiteiKb = shomei.shosikiSiteiKb;
        command.privacyConsent = store.privacyConsent;
        command.nyukyokeiyakuNo = myPageStore.selectedNyukyokeiyaku.nyukyokeiyakuNo;
        command.orgNyukyokeiyakuNo = myPageStore.selectedNyukyokeiyakuNo;
        command.rentStartDate = shomei.rentStartDate;
        command.rentEndDate = shomei.rentEndDate;
        command.shinseishaKb = shomei.isShakoShomei ? shomei.shinseishaKb : 0;
        command.shinseishaName = shomei.shinseishaName;
        command.shinseishaPostcode = shomei.shinseishaPostcode;
        command.shinseishaAdr1 = shomei.shinseishaAdr1;
        command.shinseishaAdr2 = shomei.shinseishaAdr2;
        command.shinseishaAdr3 = shomei.shinseishaAdr3;
        command.shinseishaTel = shomei.shinseishaTel;
        command.shogakukinKb = shomei.isKyojuShomei ? shomei.shogakukinKb : 0;
        command.file = shomei.file;
        return command;
    }
}
